// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16oCR","col":"styles_col__3qDGS"};